export default __webpack_public_path__ + "static/media/Sunday.e73dfb31.png";